import { Link, NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { COMPANY } from "../constants/data";

const LINKS = [
  { to: "/", label: "Accueil" },
  { to: "/services", label: "Services" },
  { to: "/projets", label: "Projets" },
  { to: "/blog", label: "Blogue" },
  { to: "/a-propos", label: "À propos" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#0A0A0A]/85 border-b border-[#262626]" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center group" data-testid="nav-logo">
          <span className="font-heading font-black text-xl tracking-tight uppercase leading-none">
            Vision<span className="text-primary"> Démolition</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) =>
                `text-sm font-semibold tracking-wide uppercase transition-colors duration-200 hover:text-primary ${isActive ? "text-primary" : "text-gray-300"}`
              }
              data-testid={`nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate("/soumission")}
            className="hidden sm:inline-flex items-center bg-primary hover:bg-[#B34015] text-white text-sm font-bold uppercase tracking-wide px-5 py-2.5 transition-colors duration-200"
            data-testid="nav-cta-soumission"
          >
            Obtenir une soumission
          </button>
          <button className="lg:hidden text-white" onClick={() => setOpen(!open)} aria-label="Menu" data-testid="nav-mobile-toggle">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#262626] bg-[#0A0A0A]" data-testid="nav-mobile-menu">
          <div className="px-5 py-4 flex flex-col gap-1">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) => `py-3 text-base font-semibold uppercase tracking-wide ${isActive ? "text-primary" : "text-gray-200"}`}
              >
                {l.label}
              </NavLink>
            ))}
            <button
              onClick={() => { setOpen(false); navigate("/soumission"); }}
              className="mt-2 bg-primary text-white font-bold uppercase tracking-wide px-5 py-3"
              data-testid="nav-mobile-cta"
            >
              Obtenir une soumission
            </button>
            <a href={COMPANY.phoneHref} className="mt-1 text-center py-3 border border-[#262626] text-gray-200 font-semibold">{COMPANY.phone}</a>
          </div>
        </div>
      )}
    </header>
  );
};
